


import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'controller/utils/@reduxjs/toolkit';
import {
  useInjectReducer,
  useInjectSaga,
} from 'controller/utils/redux-injectors';
import { success, error } from 'core/components/Notify';

import CustomResponse from 'core/utils/types/CustomResponse';
import { classSetupSaga } from './saga';
import { UserSetupState } from './types';
import { convertNaNIntoNumber } from 'core/utils/constants';

export const initialState: UserSetupState = {
  userDataList: [],
  listResponse: null,
  listModalResponse: null,
  isLoadinguserDataList: false,
  callView: false,
  erroruserDataList: undefined,
  pageIndex: 0,
  pageSize: 10,

  feedbackModalData: [],
  isLoadingFeedbackModal: false,
  errorFeedbackModal: undefined,
  isSubmittingFeedback: false,


  userData: undefined,
  isLoadinguserData: false,
  isUpsertLoading: false,

  erroruserData: undefined,

  userModalData: undefined,
  isLoadinguserModalData: false,
  erroruserModalData: undefined,

  navigate: false,
  isDeletedUserData: false,
  isUpdatedUserData: false,
  isDeletingUserData: false,
  errorDeletingUserData: {} as CustomResponse,

  backHistory: ""
};


const slice = createSlice({
  name: 'userSetup',
  initialState,
  reducers: {


    fetchUserSetupListStart(
      state,
      action: PayloadAction<{
        ID: number;
        URL: string;
        ACADEMIC_YEAR_ID?: number;
        STAFF_ROLE?: string;
        STAFF_ID?: number;
        CLASS_ID?: number;
        TABLE_CALL?: boolean;
        TABLE_DATA?: { page_size?: string | number, page_index?: string | number }
        STUDENT_CLASS_STATUS?: string;
        ADMISSION_START_DATE?: string;
        ADMISSION_END_DATE?: string;
      }>,
    ) {
      if (!action?.payload?.TABLE_CALL) {
        state.callView = false;
        state.isDeletedUserData = false;
        state.isUpdatedUserData = false;
        state.isLoadinguserDataList = true;
        state.isLoadingFeedbackModal = true;
      } else {
        state.pageIndex = convertNaNIntoNumber(Number(action?.payload?.TABLE_DATA?.page_index));
        state.pageSize = convertNaNIntoNumber(Number(action?.payload?.TABLE_DATA?.page_size));
      }
    },
    fetchUserSetupListSuccess(state, action: PayloadAction<any>) {
      state.isLoadinguserDataList = false;
      state.userDataList = action?.payload?.listData || [];
      state.listResponse = action?.payload?.data || [];
      state.feedbackModalData = action.payload?.listData || [];
      state.isLoadingFeedbackModal = false;
    },
    fetchUserSetupListFailure(state, action: PayloadAction<CustomResponse>) {
      state.isLoadinguserDataList = false;
      state.userDataList = [];
      state.listResponse = [];
      state.erroruserData = action.payload;
    },

    fetchUserSetupOneStart(
      state,
      action: PayloadAction<{
        STUDENT_CLASS_ID?: number;
        ID: number;
        START_DATE?: any;
        END_DATE?: any;
        URL: string;
        ACADEMIC_YEAR_ID?: any;
        STAFF_ROLE?: string;
        STAFF_ID?: number;
        BRANCH_ID?: number;
        queryParamas?: any;
        CALLED_FROM?: string;
      }>,
    ) {
      state.callView = false;
      state.isUpdatedUserData = false;
      if (action?.payload?.CALLED_FROM === "MODAL") {
        state.isLoadinguserModalData = true;
      } else {
        state.isLoadinguserData = true;
      }
    },
    fetchUserSetupOneSuccess(state, action: PayloadAction<any>) {
      state.isLoadinguserData = false;
      state.userData = action.payload;
      state.listResponse = action?.payload || [];
    },
    fetchUserSetupOneFailure(state, action: PayloadAction<CustomResponse>) {
      state.isLoadinguserData = false;
      state.erroruserData = action.payload;
    },

    fetchUserSetupSummaryModalSuccess(state, action: PayloadAction<any>) {
      state.isLoadinguserModalData = false;
      state.userModalData = action.payload;
      state.listModalResponse = action?.payload || [];
    },
    fetchUserSetupSummaryModalFailure(state, action: PayloadAction<CustomResponse>) {
      state.isLoadinguserModalData = false;
      state.erroruserModalData = action.payload;
    },

    // Fetch Modal Details
    fetchUserModalDetailsStart(
      state,
      action: PayloadAction<{ ID: number; URL: string }>,
    ) {
      console.log(`Fetching details for ID: ${action.payload.ID}, URL: ${action.payload.URL}`);
      state.isLoadinguserModalData = true;
      state.erroruserModalData = undefined;
    },
    fetchUserModalDetailsSuccess(state, action: PayloadAction<any>) {
      state.isLoadinguserModalData = false;
      state.userModalData = action.payload;
      state.listModalResponse = action?.payload || [];
    },
    fetchUserModalDetailsFailure(state, action: PayloadAction<CustomResponse>) {
      state.isLoadinguserModalData = false;
      state.erroruserModalData = action.payload;
    },

    createUserSetupStart(
      state,
      action: PayloadAction<{
        URL: string;
        data: any;
        action?: string;
        queryParams?: any;
        message: string;
        authData?: any;
        fromStudentActivate?: boolean;
      }>,
    ) {
      state.erroruserData = undefined;
      state.isUpsertLoading = true;
    },
    createUserSetupSuccess(state, action: PayloadAction<any>) {
      state.backHistory = action.payload.action;
      state.callView = true;
      state.isUpsertLoading = false;
      if (action.payload.URL !== "staffAttendance" && action.payload.action !== "updateFromList") {
        state.navigate = true;
      }
      if (["student", "parent", "staffLeave"].includes(action.payload.URL)) {
        state.isUpdatedUserData = true;
      }
    },
    createUserSetupFailure(state, action: PayloadAction<CustomResponse>) {
      state.isUpsertLoading = false;
      state.erroruserData = action.payload;
      error(action.payload, true);
    },

    deleteUserSetupStart(
      state,
      action: PayloadAction<{
        URL: string;
        ID: number;
        STAFF_ROLE_ID?: number;
        STAFF_ID?: number;
        CLASS_ID?: number;
        PARENT_ID?: number;
        INSTITUTE_ID?: number;
        BRANCH_ID?: number;
        isStudentInactive?: boolean;
        fromStudentActivate?: boolean;
      }>,
    ) {
      state.errorDeletingUserData = undefined;
      state.isDeletingUserData = true;
    },
    deleteUserSetupSuccess(state, action: PayloadAction<{ studentActivate?: boolean, studentInactive?: boolean }>) {
      state.isDeletingUserData = false;
      state.isDeletedUserData = true;
      success(
        action.payload.studentActivate
          ? 'Student activated Successfully'
          : action.payload.studentInactive
            ? 'Student inactivated Successfully'
            : 'Deleted Successfully',
        true
      );
    },
    deleteUserSetupFailure(state, action: PayloadAction<CustomResponse>) {
      state.isDeletingUserData = false;
      state.errorDeletingUserData = action.payload;
    },
    setTablePageSizeAndIndex(state) {
      state.pageIndex = 0;
      state.pageSize = 10;
    },
    clearUserData(state) {
      state.userDataList = [] as any[];
      state.userData = undefined;
      state.listResponse = undefined;
      state.isLoadinguserData = false;
      state.isUpdatedUserData = false;
      state.pageIndex = 0;
      state.pageSize = 10;
    },

    clearState(state) {
      state.userDataList = [];
      state.userData = undefined;
      state.listResponse = undefined;
      state.isLoadinguserData = false;
      state.isUpdatedUserData = false;
      state.feedbackModalData = [];
      state.isLoadingFeedbackModal = false;
      state.errorFeedbackModal = undefined;
      state.isSubmittingFeedback = false;
      state.pageIndex = 0;
      state.pageSize = 10;
    },

    clearModalState(state) {
      state.userModalData = undefined;
      state.listModalResponse = undefined;
      state.isLoadinguserModalData = false;
      state.feedbackModalData = [];
      state.isLoadingFeedbackModal = false;
      state.errorFeedbackModal = undefined;
      state.isSubmittingFeedback = false;
    },

    setNavigate(state, action: PayloadAction<boolean>) {
      state.navigate = action.payload;
      state.backHistory = "";
    },
  },
});

export const { actions: classSetupActions } = slice;

export const useUserSetupSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: classSetupSaga });
  return { actions: slice.actions };
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useUserSetupSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
